import { render, staticRenderFns } from "./operateDistributeConfig.vue?vue&type=template&id=0b9f0552&scoped=true"
import script from "./operateDistributeConfig.vue?vue&type=script&lang=js"
export * from "./operateDistributeConfig.vue?vue&type=script&lang=js"
import style0 from "./operateDistributeConfig.vue?vue&type=style&index=0&id=0b9f0552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f0552",
  null
  
)

export default component.exports